import React from 'react';
import { Deliver, IconProps } from 'grommet-icons';

export const EquipmentIcon: React.FC<IconProps> = ({ size = '24', color = '#EAAD47', ...iconProps }) => (
  <Deliver size={size} color={color} {...iconProps} />
);
